module.exports = __webpack_public_path__ + "static/media/Flint Hills Resources.27b70c9c.svg";